<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="12"
        sm="12"
      >
        <software-doc-table />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import softwareDocTable from './softwareDocTable.vue'

export default {
  components: {
    BRow,
    BCol,
    softwareDocTable,
  },
  data() {
    return {
      data: {},
    }
  },
  created() {
    // data
    this.$http.get('/analytics/data')
      .then(response => { this.data = response.data })
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>